export class GameLoader
{
    constructor(elm)
    {
        this.elm = elm;
        if (this.elm.hasAttribute('data-src')) {
            this.url = this.elm.getAttribute('data-src');
            this.timeoutLoader = null;
            this.init();
        } else {
            this.elm.remove();
        }
    }

    init()
    {
        this.bindLoader();
        this.bindFullscreen();
    }

    onFullscreen(exitEvent)
    {
        this.toggleFullscreenMode();
        document.addEventListener(exitEvent, this.toggleFullscreenMode.bind(this), {once: true});
    }

    toggleFullscreenMode()
    {
        this.elm.classList.toggle('game-loader--fullscreen');
    }

    openFullscreen()
    {
        if (document.body.requestFullscreen) {
            document.addEventListener('fullscreenchange', this.onFullscreen.bind(this, 'fullscreenchange'),
                {once: true});

            this.elm.requestFullscreen().catch((err) => {
                console.error(err);
            });
        } else {
            if (document.body.webkitRequestFullscreen) {
                document.addEventListener('webkitfullscreenchange',
                    this.onFullscreen.bind(this, 'webkitfullscreenchange'), {once: true});

                try {
                    this.elm.webkitRequestFullscreen();
                } catch (e) {
                    console.error(e);
                }
            } else {
                this.elm.classList.toggle('game-loader--fullscreen');
            }
        }
    }

    closeFullscreen()
    {
        if (document.exitFullscreen) {
            document.exitFullscreen().catch((err) => {
                console.error(err);
            });
        } else {
            if (document.webkitExitFullscreen) {
                try {
                    document.webkitExitFullscreen();
                } catch (e) {
                    console.error(e);
                }
            } else {
                this.elm.classList.toggle('game-loader--fullscreen');
            }
        }
    }

    bindFullscreen()
    {
        let that = this;

        let fullscreenToggle = this.elm.querySelector('.evt-toggle-fullscreen');
        if (fullscreenToggle) {
            fullscreenToggle.addEventListener('click', () => {
                if (that.elm.classList.contains('game-loader--fullscreen')) {
                    this.closeFullscreen();
                } else {
                    this.openFullscreen();
                }
            });
        }
    }

    finishLoading(iframe)
    {
        let iframeContent = iframe.contentDocument || iframe.contentWindow.document;
        let html = iframeContent.querySelector('html');
        let that = this;

        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.target.classList.contains('wf-active')) {
                    that.elm.classList.add('game-loader--ready');
                    observer.disconnect();
                    clearTimeout(that.timeoutLoader);

                    let loaderElm = that.elm.querySelector('.loading-animation');
                    if (loaderElm) {
                        loaderElm.remove();
                    }
                }
            });
        });

        observer.observe(html, {
            attributes: true //configure it to listen to attribute changes
        });
    }

    bindLoader()
    {
        let startBtn = this.elm.querySelector('.evt-start-game');
        if (startBtn) {
            startBtn.addEventListener('click', () => {
                if (!this.elm.classList.contains('game-loader--loading')) {
                    this.elm.classList.add('game-loader--loading');

                    let iframe = document.createElement('iframe');
                    iframe.onload = () => {
                        this.finishLoading(iframe);
                    };
                    iframe.setAttribute('class', 'game-loader__iframe');
                    iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts');
                    iframe.setAttribute('frameborder', '0');
                    iframe.src = this.url;

                    let gameContainer = this.elm.querySelector('.game-loader__game');
                    gameContainer.appendChild(iframe);

                    this.timeoutLoader = setTimeout(() => {
                        window.bo.loaderElement.appendTo(this.elm);
                    }, 2000);
                }
            });
        }
    }
}
